import React from "react";
import clsx from "clsx";

import styles from "./RichContent.module.css";

export default React.forwardRef(function RichContent(
  { tag: Tag = "div", className, ...rest },
  ref,
) {
  return (
    <Tag ref={ref} className={clsx(styles.content, className)} {...rest} />
  );
});
